export default "/kiban/_next/static/images/silver-49df033a57c963c99ee3f94fd3967470.gif";